import { useEffect, useRef } from "react";
import { getConsent } from "../lib/consent";

const CLIENT = process.env.REACT_APP_ADSENSE_CLIENT;
const SLOT = process.env.REACT_APP_ADSENSE_SLOT;
export const ADSENSE_ON = !!(CLIENT && SLOT);

const loadScript = () => {
  if (document.getElementById("adsbygoogle-js")) return;
  const s = document.createElement("script");
  s.id = "adsbygoogle-js";
  s.async = true;
  s.crossOrigin = "anonymous";
  s.src = `https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js?client=${CLIENT}`;
  document.head.appendChild(s);
};

export const AdSlot = () => {
  const ref = useRef(null);
  useEffect(() => {
    loadScript();
    const q = (window.adsbygoogle = window.adsbygoogle || []);
    q.requestNonPersonalizedAds = getConsent()?.ads ? 0 : 1;
    // wait for the dialog open animation so the slot has a real width
    const id = setTimeout(() => { try { q.push({}); } catch (e) { /* ad blocked */ } }, 400);
    return () => clearTimeout(id);
  }, []);
  return (
    <ins ref={ref} className="adsbygoogle block min-h-[180px] w-full" data-testid="adsense-slot" style={{ display: "block" }}
      data-ad-client={CLIENT} data-ad-slot={SLOT} data-ad-format="auto" data-full-width-responsive="true" />
  );
};
